export const TESTIMONIALS = [
  {
    description:
      'Amazeballs!! This is our 2nd Catamaran trip and it was 100 times better than our last. This crew is top notch! Thank you for the information Guidance and kindness',
    name: 'Jerry Chase',
    title: 'AZ, USA',
  },
  {
    description:
      'Thank you! Thank you! Thank you! This has been the most amazing trip ever. The captain & crew are the best! I loved every minute and cant wait to do it again.',
    name: 'Dave & Jeff',
    title: 'NY, USA',
  },
  {
    description:
      'What an amazing experience! This crew, Jordan, Matron and Giami are excellent! The service, the food the attention to detail were outstanding! You truly made this a trip for a lifetime. May our paths cross again!',
    name: 'Brad',
    title: 'CA, USA',
  },
  {
    description:
      'Words can not describe how amazing everything has been these past weeks. The crew was like family, We loved every second! The food hands down was the best we have ever had. We will be back! Thank you for everything!',
    name: 'Bob & David',
    title: 'TX, USA',
  },
  {
    description:
      'WOW!... I just cant find the words to describe this experience! The crew was absolute amazing and how they took care of us in every was beyond belief. My only regret is that we have to leave. Thank you for everything!',
    name: 'Laudia',
    title: 'HB, GERMANY',
  },
  {
    description:
      'Thank you for another fantastic holiday! Giavanis was a food magician.',
    name: 'Anne Halfhide',
    title: 'SYDNEY, NSW, AUSTRALIA',
  },
]
